export default __webpack_public_path__ + "static/media/login-banner.63b6c1ea.svg";